import React from 'react'

import useTranslation from '../../../context/hooks/useTranslation'

export interface ScanResultKeepOnHubProps {
  lastDriver: string
  address: string
  postalCode: string
  city: string
  tel: string
  sender: string
}

export const ScanResultKeepOnHub: React.FC<ScanResultKeepOnHubProps> = ({
  lastDriver,
  address,
  postalCode,
  city,
  tel,
  sender,
}) => {
  const { t } = useTranslation()

  return (
    <div className="shadow-elevation-2 flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white">
      <div className="flex w-1/2 flex-col items-center justify-center gap-4 bg-green-50">
        <span className="font-heading text-[40px] text-indigo-50">
          {t('RETURNS_SCAN.KEEP_IN_REGION').toUpperCase()}
        </span>
      </div>

      <div className="flex w-1/2 flex-col items-start p-10 text-indigo-50">
        <div className="font-body text-md flex flex-col gap-7">
          <div className="flex flex-col">
            <span className="font-heading">
              {t('RETURNS_SCAN.LAST_DRIVER')}
            </span>
            <span>{lastDriver}</span>
          </div>

          <div className="flex flex-col">
            <span className="font-heading">{t('RETURNS_SCAN.ADDRESS')}</span>
            <span>{`T: +${tel}`}</span>
            <span>{address}</span>
            <span>{`${postalCode} ${city}`}</span>
          </div>

          <div className="flex flex-col">
            <span className="font-heading">{t('RETURNS_SCAN.SENDER')}</span>
            <span>{sender}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ScanResultKeepOnHub
